import { Component, DestroyRef, Inject, ViewChild, inject } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ServicesService } from 'src/services/services.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';

export interface SponsorData {
  s_id: any;
}

export interface EventElement {
  s_id: string;
  image_name: any;
  sponsor_name: string;
  mobile: string;
  amount: string;
  action: any;
}

@Component({
  selector: 'app-sponsor',
  templateUrl: './sponsor.component.html',
  styleUrls: ['./sponsor.component.scss']
})
export class SponsorComponent {
  displayedColumns: string[] = [
    's_id',
    'image_name',
    'sponsor_name',
    'mobile',
    'amount',
    'action',
  ];

  ELEMENT_DATA: EventElement[] = [];
  a_result: any;
  event_id: any;

  private destoryRef = inject(DestroyRef);

  dataSource = new MatTableDataSource<EventElement>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  s_id: any;

  constructor(private service: ServicesService,
    private router: Router,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
  ) { }

  ngAfterViewInit() {
    this.event_id = sessionStorage.getItem('Event_ID');
    this.Get_Sponsor(this.event_id);
    this.dataSource.paginator = this.paginator;
  }

  AddSponsor() {
    const dialogRef = this.dialog.open(add_sponsor, {
      data: {
        s_id: this.s_id
      },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.Get_Sponsor(this.event_id);
    });
  }

  EditSponsor(s_id: any) {
    const dialogRef = this.dialog.open(add_sponsor, {
      data: {
        s_id: s_id
      },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.Get_Sponsor(this.event_id);
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  Get_Sponsor(event_id: any) {
    this.ELEMENT_DATA = [];
    this.spinner.show();
    this.service.getSponsor(event_id).pipe(takeUntilDestroyed(this.destoryRef), finalize(() => this.spinner.hide())).subscribe(
      (data: any) => {
        this.a_result = data.data
        for (const item of this.a_result) {
          this.ELEMENT_DATA = this.a_result.map((item: { image_name: any; sponsor_name: any; mobile: any; amount: any; s_id: any; }, index: number) => ({
            srNo: index + 1,
            sponsor_name: item.sponsor_name,
            image_name: item.image_name,
            s_id: item.s_id,
            mobile: item.mobile,
            amount: item.amount,
            action: item.s_id
          })
          );
        }
        this.dataSource = new MatTableDataSource<EventElement>(this.ELEMENT_DATA);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.spinner.hide();
      }
    );
  }

  delete_sponsor(s_id: any) {
    const buttonClicked = window.confirm('Are You Sure To Delete This Sponsor?');
    if (buttonClicked === true) {

      this.service.delete_sponsor(s_id).pipe(takeUntilDestroyed(this.destoryRef)).subscribe(
        data => {
          this.ELEMENT_DATA = this.ELEMENT_DATA.filter(item => item.s_id !== s_id);
          this.dataSource.data = this.ELEMENT_DATA;
          this.toastr.success("Sponsor Deleted Succesfully");
        });
    }
  }
}


@Component({
  selector: 'add_sponsor',
  templateUrl: './add_sponsor.html',
  styleUrls: ['./sponsor.component.scss'],
  standalone: false
})
export class add_sponsor {

  SponsorForm: FormGroup;
  s_id: any
  result: any;
  hide = true;
  point: any
  private destoryRef = inject(DestroyRef);
  point_data: any;
  event_id: any;
  updated_by: any;
  sponsor_name: any;
  mobile: any;
  amount: any;
  category: any;
  website: any;
  message!: string;
  imagefileURL!: any | ArrayBuffer;
  imagePath: any;
  isOld1: boolean = false;
  image_name: any;

  constructor(
    private member: FormBuilder,
    private service: ServicesService,
    private dialogRef: MatDialogRef<add_sponsor>,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: SponsorData
  ) {
    this.s_id = data['s_id'];
    this.SponsorForm = this.member.group({
      s_id: this.s_id,
      sponsor_name: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/),]),
      mobile: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/),]),
      amount: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/),]),
      image_name: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/),]),
      category: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/),]),
      website: new FormControl('', [Validators.pattern(/^(\s*\S+\s*)+$/),]),
    });
  }

  ngOnInit(): void {
    this.event_id = sessionStorage.getItem('Event_ID');
    this.updated_by = sessionStorage.getItem('User_ID');
    this.getSponsorByID(this.s_id);
  }

  getSponsorByID(s_id: any) {
    console.log(s_id);

    this.service.getSponsorByID(s_id).subscribe(
      (data: any) => {
        this.point_data = data.data;
        this.s_id = this.point_data[0].s_id;
        this.sponsor_name = this.point_data[0].sponsor_name;
        this.mobile = this.point_data[0].mobile;
        this.amount = this.point_data[0].amount;
        this.image_name = this.point_data[0].image_name;
        this.category = this.point_data[0].category;
        this.website = this.point_data[0].website;
      });
    this.isOld1 = true;
  }

  previewpimage(files: any) {
    console.log(files);
    if (files.length === 0) {
      return;
    }
    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = 'Only images are supported.';
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imagefileURL = reader.result;
      this.service.uploadimage(this.imagefileURL, this.event_id + "/sponsor").subscribe((data: any) => {
        this.imagePath = data['image_name'];
        console.log(this.imagePath);
        this.isOld1 = false;
        this.SponsorForm.patchValue({
          image_name: this.imagePath
        })
      });
    };
  }

  onFormSubmit() {
    const formData = this.SponsorForm.value;
    const hasNonEmptyField = Object.values(formData).some(value => value !== null && value !== '');
    if (this.SponsorForm.valid && hasNonEmptyField) {

      if (this.s_id) {
        this.service.edit_sponsor(this.SponsorForm.value, this.updated_by).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({
          next: (val: any) => {
            this.toastr.success("Artist Updated Succesfully");
            this.dialogRef.close(true);
          },
          error: (err: any) => {
            console.error(err);
          },
        });
      } else {
        this.service.add_sponsor(this.SponsorForm.value, this.updated_by).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({

          next: (val: any) => {
            this.toastr.success("Artist Added Succesfully");
            this.dialogRef.close(true);
          },
          error: (err: any) => {
            console.error(err);
          },
        });
      }
    } else {
      this.toastr.error("Please Fill Required Fields")
    }
  }
}